import React, { useState } from "react";
import { Calendar, ChevronDown, ChevronUp } from "lucide-react";

const DayFilter = ({ selectedDay, onDayChange, days }) => {
  const [isOpen, setIsOpen] = useState(false);
  
  return (
    <div className="day-filter-container">
      <div className="day-filter-header">
        <div className="day-filter-title">
          <Calendar size={20} className="day-filter-icon" />
          <h3 className="day-filter-heading">Event Analytics</h3>
        </div>
        <div className="day-filter-actions">
          <div className="day-filter-dropdown">
            <button 
              className="day-filter-btn" 
              onClick={() => setIsOpen(!isOpen)}
            >
              {selectedDay === "all" ? "All Days" : `Day ${selectedDay.split(" ")[1]}`}
              {isOpen ? <ChevronUp size={18} /> : <ChevronDown size={18} />}
            </button>
            {isOpen && (
              <div className="day-filter-menu">
                {days.map((day, index) => (
                  <button
                    key={index}
                    className={`day-filter-option ${selectedDay === day.toLowerCase() ? "active" : ""}`}
                    onClick={() => {
                      onDayChange(day.toLowerCase());
                      setIsOpen(false);
                    }}
                  >
                    {day}
                  </button>
                ))}
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default DayFilter;